/* eslint-disable @typescript-eslint/no-explicit-any */
import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { resetCaptcha } from 'entities/index';

interface RejectedAction {
  payload?: {
    status?: number;
    data?: {
      message?: string;
    };
    isAxiosError?: boolean;
  };
  error?: any;
}

export const captchaMiddleware: Middleware = (store) => (next) => (action) => {
  if (!isRejectedWithValue(action)) {
    return next(action);
  }
  const rejectedAction = action as RejectedAction;
  const error = rejectedAction.payload || rejectedAction.error;
  if (
    error?.isAxiosError &&
    (error?.response?.status === 401 || error?.response?.status === 403)
  ) {
    store.dispatch(resetCaptcha());
  }

  return next(action);
};
